import MenuFavorites from './MenuFavorites'

export default MenuFavorites
